export default __webpack_public_path__ + "static/media/G_D_btn__Archivio.1960226e.svg";